import { FbMember } from '../constants'
import { fbMemberName } from '../utils'
import { getProfile } from '../random-fb-profile'

export default {
  injectModels: ['Store'],
  methods: {
    name: fbMemberName,
    memberFromRef(ref) {
      if (!ref)
        return null

      const code = ref[1]
      const id = ref.substr(3)

      if (code === 'R')
        return {
          id: `RAND_${id}`,
          type: FbMember.Profile,
          route: `/fb-profiles/RAND_${id}`,
          member: getProfile(id, this.Store)
        }


      const { path, type } = {
        u: { path: 'profiles', type: FbMember.Profile },
        p: { path: 'pages', type: FbMember.Page }, 
        g: { path: 'groups', type: FbMember.Group }
      }[code]

      const route = `/fb-${path}/${id}`
      const member = this.Store.fb[path][id]

      if (member == null)
        return null
      return { id, type, route, member }
    }
  }
}